import React, { useState, useEffect } from 'react';
import styles from './Header.module.css';
import { NavLink } from "react-router-dom";
import { allProducts, ALL_PRODUCTS } from './../API/ProductsAPI';

const Header = (props) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [showHeader, setShowHeader] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
    };

    const refreshHomePage = () => {
        props.setActiveCategory(ALL_PRODUCTS);
        props.setProducts(allProducts);
    };

    const handleScroll = () => {
        const currentScrollY = window.scrollY;

        if (currentScrollY > lastScrollY) {
            // Scroll în jos
            setShowHeader(false);
        } else {
            // Scroll în sus
            setShowHeader(true);
        }

        setLastScrollY(currentScrollY);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [lastScrollY]);

    return (
        <header className={`${styles.header} ${showHeader ? styles.visible : styles.hidden}`}>
            <div className={styles.container}>
                <a href="/" className={styles.logo}>
                    <img src="/logo.png" alt="Logo" />
                </a>
                <nav className={`${styles.nav} ${styles.desktopNav}`}>
                    <ul>
                        <li><NavLink to="/" className={({ isActive }) => (isActive ? 'active' : '')}>Acasa</NavLink></li>
                        <li><NavLink to="/shop" onClick={refreshHomePage} className={({ isActive }) => (isActive ? 'active' : '')}>Produse</NavLink></li>
                        <li><NavLink to="/about" className={({ isActive }) => (isActive ? 'active' : '')}>Despre noi</NavLink></li>
                        <li><NavLink to="/contact" className={({ isActive }) => (isActive ? 'active' : '')}>Contacte</NavLink></li>
                    </ul>
                </nav>
                <div className={styles.rightActions}>
                    <NavLink to="/cart"><i className="fa-solid fa-cart-shopping" />
                        {(props.nrProducts > 0) && <sup className={styles.sup}>{props.nrProducts}</sup>} Coșul meu</NavLink>
                </div>
                <button className={styles.hamburger} onClick={toggleMenu}>
                    <i className="fa-solid fa-bars" />
                </button>
                <nav className={`${styles.mobileNav} ${isMenuOpen ? styles.open : ''}`}>
                    <ul>
                        <li><NavLink to="/" onClick={toggleMenu}>Acasa</NavLink></li>
                        <li><NavLink to="/shop" onClick={toggleMenu}>Produse</NavLink></li>
                        <li><NavLink to="/contact" onClick={toggleMenu}>Contacte</NavLink></li>
                        <li><NavLink to="/about" onClick={toggleMenu}>Despre noi</NavLink></li>
                        <li><NavLink to="/cart" onClick={toggleMenu}><i className="fa-solid fa-cart-shopping" />
                            {(props.nrProducts > 0) && <sup className={styles.sup}>{props.nrProducts}</sup>} Coșul meu</NavLink></li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;